// Dialog utility functions
import { getChatPayloadPreview } from "../../../chat/contentPayloads";

function cleanDialogPreviewText(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return "";

  const direct = String(getChatPayloadPreview(raw) || "").trim();
  if (direct && !direct.startsWith("%%BUROSOUL_")) return direct;

  const tokenIndex = raw.indexOf("%%BUROSOUL_");
  if (tokenIndex >= 0) {
    const before = raw.slice(0, tokenIndex).replace(/[:\s]+$/g, "").trim();
    const payloadPreview = String(getChatPayloadPreview(raw.slice(tokenIndex)) || "").trim();
    const safePayloadPreview = payloadPreview && !payloadPreview.startsWith("%%BUROSOUL_") ? payloadPreview : "Рекомендация";
    return before ? `${before}: ${safePayloadPreview}` : safePayloadPreview;
  }

  return raw;
}

export function isGroupDialog(dialog) {
  if (!dialog) return false;
  if (typeof dialog.type === "string") return dialog.type.toUpperCase() === "GROUP";
  if (dialog.isGroup != null) return Boolean(dialog.isGroup);
  if (Number.isFinite(Number(dialog.membersCount))) return Number(dialog.membersCount) > 2;
  if (Array.isArray(dialog.members) && dialog.members.length) return dialog.members.length > 2;
  return false;
}

export function isArchivedDialog(dialog) {
  return Boolean(dialog?.archived || dialog?.isArchived || dialog?.inArchive);
}

export function getDialogTitle(dialog) {
  return String(dialog?.title || "Без названия").trim() || "Без названия";
}

export function getDialogPreview(dialog) {
  if (dialog?.typing) return "печатает...";
  const text = cleanDialogPreviewText(dialog?.lastMessage);
  if (text) {
    const sender = String(dialog?.lastMessageSender || "").trim();
    const alreadyPrefixed = sender && text.toLowerCase().startsWith(`${sender.toLowerCase()}:`);
    if (sender && isGroupDialog(dialog) && !alreadyPrefixed) {
      return `${sender}: ${text}`;
    }
    return text;
  }
  return "Сообщений пока нет";
}
